import phoneValidationController from './phoneValidation.controller';
import template from './phoneValidation.html';
import { API } from '../../../../common/config/config';

function phoneValidationFactory($mdDialog, $http) {
  function showPhoneValidationDialog(user, number) {
    $mdDialog.show({
      template,
      controller: phoneValidationController,
      controllerAs: '$ctrl',
      locals: { user, number },
    });
  }
  function sendCode({ user, number }) {
    return $http
      .post(`${API}/user/${user._id}/send-validation-phone`, { number })
      .then(response => response.data);
  }
  function validateCode({ user, code, number }) {
    return $http
      .post(`${API}/user/${user._id}/validate-phone`, { number, code })
      .then(response => response.data);
  }
  return { showPhoneValidationDialog, sendCode, validateCode };
}
phoneValidationFactory.$inject = ['$mdDialog', '$http'];
export default phoneValidationFactory;



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/phoneValidation/phoneValidation.factory.js